import Hourglass20 from '@carbon/icons-react/es/hourglass/20';
import React, { FC } from 'react';
import styled from 'styled-components';
import { MaskableContent } from 'components/atoms/maskable-content';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { Helium } from 'components/templates';
import { useTranslation } from 'hooks/use-translation';
import { ApprovalsSettings } from './approvals-settings';
// import { CapacitySettings } from './capacity';
import { useCategories } from './categories';
import { CategoriesSettings } from './categories-settings';
import { Divider, Section } from './components';
import { DueSettings } from './due-settings';
import { EntryTypeSettings } from './entry-type-settings';
import { ExcludedUsersSettings } from './excluded-users-settings';
import { FeatureSwitch } from './feature-switch';
import { GoogleCalendar } from './google-calendar';
import { LockTimeSettings } from './lock-time-settings';
import { RemindersSettings } from './reminders-settings';
import { SubmissionHours } from './submission-hours';
import { useApprovalSettings } from './use-approval-settings';
import { useCapacity } from './use-capacity';
import { useCategory } from './use-category-';
import { useConfiguration } from './use-configuration';
import { useDue } from './use-due';
import { useEnabledSources } from './use-enabled-sources';
import { useFeatureSettings } from './use-feature-setting';
import { useLockTimesheet } from './use-lock-settings';
import { useReminders } from './use-reminders';
import { useSubmissionHours } from './use-submission-hours';
// import { useWorkingDays } from './use-working-days';
// import { WorkingDaysSettings } from './working-days';

const SectionStyled = styled(Section)`
  width: 70%;
`;

export const TimesheetSettings: FC = () => {
  const title = useTranslation('settings.timesheets.title');
  const documentTitle = useTranslation('settings.timesheets.title.document');
  const { categories, remove, create, update } = useCategories();
  const [config, setConfig] = useConfiguration();
  const [aprrovalType, setAprrovalType] = useApprovalSettings(
    config,
    setConfig,
  );
  const [enabledSources, setEnabledSources] = useEnabledSources(
    config,
    setConfig,
  );
  const [lockSettings, setLockSettings] = useLockTimesheet(config, setConfig);

  const [capacity] = useCapacity(config, setConfig);

  const [due, setDue] = useDue(config, setConfig);
  const [reminder, setReminder] = useReminders(config, setConfig);
  const [submissionHours, setSubmissionHours] = useSubmissionHours(
    config,
    setConfig,
  );
  const [featureEnabled, setFeatureEnabled] = useFeatureSettings();
  const [categoryMandatory, setCategoryMandatory] = useCategory(
    config,
    setConfig,
  );

  return (
    <Helium
      title={<HeaderWithIconTitle icon={<Hourglass20 />} title={title} />}
      documentTitle={documentTitle}
    >
      <section>
        <FeatureSwitch
          enabled={featureEnabled}
          onStateChange={setFeatureEnabled}
        />
      </section>
      <MaskableContent
        showMask={!featureEnabled}
        data-cy="timesheet-settings-content"
      >
        <Section>
          <DueSettings due={due} onDueChange={setDue} />
          <RemindersSettings
            reminder={reminder}
            onReminderChange={setReminder}
          />
        </Section>
        <Divider />
        {/* <Section>
          <CapacitySettings
            capacity={capacity}
            onCapacityChange={setCapacity}
          />
          <WorkingDaysSettings
            configuration={workingDays}
            onConfigurationChange={setWorkingDays}
          />
        </Section>
        <Divider /> */}
        <Section>
          <EntryTypeSettings
            configuration={enabledSources}
            onConfigurationChange={setEnabledSources}
          />
        </Section>
        <Divider />
        <SectionStyled>
          <LockTimeSettings
            configuration={lockSettings}
            onConfigurationChange={setLockSettings}
          />
        </SectionStyled>
        <Divider />
        <Section>
          <GoogleCalendar />
        </Section>
        <Divider />
        <Section data-cy="settings.timesheets.submissionHours">
          <SubmissionHours
            capacity={capacity}
            submissionHours={submissionHours}
            onSubmissionHoursChange={setSubmissionHours}
          />
        </Section>
        <Divider />
        <Section>
          <CategoriesSettings
            categories={categories}
            onDelete={remove}
            onAdd={create}
            onUpdate={update}
            categoryMandate={categoryMandatory}
            setMandatory={setCategoryMandatory}
          />
        </Section>
        <Divider />
        <Section>
          <ApprovalsSettings
            approvalType={aprrovalType}
            onApprovalTypeChange={setAprrovalType}
          />
        </Section>
        <Divider />
        <Section data-cy="settings.timesheets.exclude">
          <ExcludedUsersSettings />
        </Section>
      </MaskableContent>
    </Helium>
  );
};
